<template>
  <v-container>
    <div class="d-flex align-center mt-8 mb-8">
      <span class="headline font-weight-bold primary--text">Especies</span>
      <v-spacer></v-spacer>

      <v-text-field
        v-model="searchText"
        @input="onChangeSearchText"
        outlined
        clearable
        hide-details
        prepend-inner-icon="search"
        rounded
        placeholder="Buscar"
      ></v-text-field>
    </div>

    <div class="d-flex flex-column flex-sm-row">
      <div class="d-flex flex align-center">
        <span class="subheading primary--text font-weight-bold">Filtros:</span>
        <v-chip-group
          class="ml-2"
          v-model="validated"
          active-class="primary"
          mandatory
          @change="onChangeSearchText"
        >
          <v-chip :value="true">Validados</v-chip>
          <v-chip :value="false">Por validar</v-chip>
        </v-chip-group>
      </div>
      <div class="d-flex align-center">
        <OrganismImport v-on:import="reloadData"></OrganismImport>
        <v-btn color="primary" @click="dialogForm = true" class="ml-4" rounded>
          <span class="font-weight-bold">Nuevo</span>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollInfiniteDisabled"
      infinite-scroll-distance="10"
    >
      <transition-group
        name="slide-x-transition"
        tag="div"
        class="d-flex flex-wrap"
        hide-on-leave
      >
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="organism in organismList"
          :key="organism.id"
        >
          <OrganismItemCard :item="organism"></OrganismItemCard>
        </v-col>
      </transition-group>
    </div>
    <transition>
      <div v-if="loading">
        <v-row class="pa-4 pt-0">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(item, index) of [1, 2, 3, 4, 5, 6]"
            :key="index"
          >
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </transition>

    <v-dialog v-model="dialogForm" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline">
          <span>Nueva especie</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialogForm = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <OrganismAddNewForm
          v-on:submitted="dialogForm = false"
        ></OrganismAddNewForm>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import OrganismAddNewForm from "./OrganismAddNewForm";
import OrganismItemCard from "../Organism/OrganismItemCard";
import OrganismImport from "./OrganismImport";
export default {
  components: { OrganismAddNewForm, OrganismItemCard, OrganismImport },
  data: () => ({
    organismRegister: {},
    dialogForm: false,
    snackForm: false,
    searchText: "",
    snackFormSuccess: false,
    organism: {},
    organismList: [],
    loading: true,
    items: [],
    model: null,
    search: null,
    tab: null,
    page: 1,
    limit: 15,
    scrollInfiniteDisabled: false,
    validated: true,
    _timerId: null
  }),
  methods: {
    async reloadData() {
      this.organismList = [];
      this.getData();
    },
    async getData() {
      try {
        this.loading = true;
        this.scrollInfiniteDisabled = true;
        let { data: organismList = [] } = await this.$http.get("organism", {
          params: {
            where: {
              searchText: {
                contains: (this.searchText || "").toLowerCase()
              },
              validated: this.validated,
              deleted: false
            },
            sort: "ocurrenceFrecuency DESC",
            limit: this.limit,
            skip: (this.page - 1) * this.limit
          }
        });
        setTimeout(() => {
          this.organismList.push(...organismList);
          if (organismList.length == this.limit) {
            this.scrollInfiniteDisabled = false;
          }
        }, 200);
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
      this.loading = false;
    },
    async loadMore() {
      this.page++;
      this.getData();
    },
    async onChangeSearchText() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.organismList = [];
        this.page = 1;
        this.getData();
      }, 800);
    },
    async createOrganism() {
      try {
        this.snackForm = true;
        this.dialogForm = false;
        await this.$http.post("organism", {
          ...this.organismRegister
        });
        this.snackFormSuccess = true;
        this.onChangeSearchText();
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
    }
  },
  mounted: function() {
    this.getData();
  }
};
</script>
